module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.7940efc4.ttf";